import { SelectBox } from 'devextreme-react';
import React, { Component } from 'react';
import { SERVICE_NOTE_STATUS } from '../../constants/Config';
import i18n from '../../i18n';
import PropTypes from 'prop-types';

class ServiceNoteProcessStatusSelectBox extends Component {
    constructor(props) {
        super(props);

        this.state = {
            datas: {}
        };

        this.onDataChanged = this.onDataChanged.bind(this);
    }

    componentDidMount() {
        this.handleLanguage();
    }

    handleLanguage = () => {
        const { languages, pathName } = this.props;

        let datas = [];
        const statusArray = (pathName === '/work-list') ? SERVICE_NOTE_STATUS.filter(item => [1, 2, 3, 4].includes(item.id)) : SERVICE_NOTE_STATUS;
        languages.forEach(element => {
            const newArray = [];

            for (const item of statusArray) {
                const i = Object.assign({}, item);
                const nameParse = (i.name ? JSON.parse(i.name) : '');

                i.name = nameParse[element.languageId];
                newArray.push(i);
            }

            datas = { ...datas, [element.languageId]: newArray };
        });

        this.setState({
            datas
        });
    }

    /**
     * Handle Data Change.
     *
     * @inheritdoc
     */
    onDataChanged(e) {
        const { field } = this.props;

        this.props.updateData({
            [field]: e.value
        });
        if (e.value === null) {
            const { field } = this.props;

            this.props.updateData({
                [field]: null
            });
        }
    }

    render() {
        const { currentLanguageActive, value, i18nLabel, disabled, showClearButton } = this.props;
        const { datas } = this.state;

        return (
            <div className="form-group cm-mgr-5">
                <div className={'dx-field'}>
                    <SelectBox
                        searchEnabled={true}
                        items={datas[currentLanguageActive]}
                        value={value}
                        showClearButton={showClearButton !== undefined ? showClearButton : true}
                        valueExpr={'id'}
                        displayExpr={'name'}
                        placeholder={i18n.t(i18nLabel)}
                        disabled={disabled}
                        onValueChanged={this.onDataChanged}
                    />
                </div>
            </div>
        );
    }
}

ServiceNoteProcessStatusSelectBox.propTypes = {
    currentLanguageActive: PropTypes.string,
    value: PropTypes.string,
    i18nLabel: PropTypes.string,
    languages: PropTypes.array,
    field: PropTypes.string,
    pathName: PropTypes.string,
    updateData: PropTypes.func,
    disabled: PropTypes.bool,
    showClearButton: PropTypes.bool
};

export default ServiceNoteProcessStatusSelectBox;
